export default __webpack_public_path__ + "static/media/Nick_Jr.699e7d33.png";